import { Form } from "components/Forms";
import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import {
  Action,
  Container,
  DownloadFile,
  Heading3,
  Icon,
  ModalWrapper,
  OrderedList,
  PageLink,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./Content052.module.scss";

export const Content052 = ({ payload }) => {
  const title = payload?.title ?? "";
  const blocks = payload?.blocks ?? [];
  const attachment = payload?.attachment ?? {};
  const type = payload?.button?.type ?? "form";
  const buttonText = payload?.button?.buttonText ?? "";
  const link = payload?.button?.link ?? "";
  const form = payload?.button?.form ?? {};
  const { t } = useTranslation();

  const instanceId = buildWidgetInstanceId(
    "052",
    payload.id,
    WIDGETS_REGISTRY.CONTENT
  );

  const { query } = useRouter();

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <div className={styles.blocks}>
          <div className={styles.left}>
            <Heading3 as="h3" className={styles.title}>
              {title}
            </Heading3>
            {type === "form" ? (
              <Action onClick={onOpen} className={styles.play}>
                <span className={styles.arrow}>
                  <Icon className={styles.icon} name="arrow_right" />
                  <Paragraph color="brand" appearance="bigger">
                    {buttonText}
                  </Paragraph>
                </span>
              </Action>
            ) : (
              <PageLink link={link} className={styles.play}>
                <span className={styles.arrow}>
                  <Icon className={styles.icon} name="arrow_right" />
                  <Paragraph color="brand" appearance="bigger">
                    {buttonText}
                  </Paragraph>
                </span>
              </PageLink>
            )}

            {opened && (
              <ModalWrapper onCloseModal={onClose}>
                <Form
                  item={form}
                  metaData={{ page: query.slug }}
                  instanceId={instanceId}
                  onReset={onClose}
                />
              </ModalWrapper>
            )}
          </div>
          <div className={styles.right}>
            <OrderedList
              items={blocks}
              className={styles.list}
              appearance="bold"
            />
            <DownloadFile file={attachment} label={t("download_file")} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content052;
